import React from 'react'
import AnnotationDroplist from './AnnotationDroplist'
import AnnotationColorHelper from './AnnotationColorHelper'

class DesignerAnnotationHeader extends React.Component {
  constructor(props) {
    super(props)
    this.state = { type: this.props.annotation.type_label || "Comment" }
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleSelect(evt) {
    this.setState({type: evt.target.innerText})
    this.props.handleTypeChange(evt.target.innerText)
  }

  annotationTypes() {
    return [{label: "Comment"}, {label: "CSR Note"}]
  }

  render() {
    const headerklass = AnnotationColorHelper({}, this.state.type)

    return (
      <div className={`${headerklass} py-2 d-flex flex-row`}>
        <div className="d-flex flex-column col-10">
          <h3 className="text-white mb-0 py-1 px-1">{this.state.type}</h3>
        </div>
        { this.props.triDot &&
          <div className="col text-center">
            <AnnotationDroplist
              onSelect={this.handleSelect}
              annotationTypes={this.annotationTypes()}
            />
          </div>
        }
      </div>
    )
  }
}

export default DesignerAnnotationHeader
